import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Clock, ListChecks, Pencil, Users } from "lucide-react";

const STATUS_LABEL = { draft: "Nháp", published: "Công bố", active: "Đang mở", reviewing: "Đang chấm", finalized: "Đã kết thúc", archived: "Lưu trữ" };

export default function ContestsList() {
    const [contests, setContests] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/contests").then((r) => { setContests(r.data.contests || []); setLoading(false); });
    }, []);

    return (
        <main className="pt-24 pb-12 min-h-screen">
            <div className="container-x">
                <div className="mb-10 fade-up">
                    <div className="text-xs uppercase tracking-widest text-[var(--gold-deep)] mb-2">Danh sách</div>
                    <h1 className="font-heading text-3xl sm:text-4xl font-bold">Cuộc thi trên nền tảng</h1>
                    <p className="text-slate-500 mt-2 max-w-2xl">Lựa chọn cuộc thi phù hợp để tham gia. Tất cả cuộc thi đều có AI hỗ trợ chấm sơ bộ.</p>
                </div>

                {loading ? (
                    <div className="grid md:grid-cols-2 gap-6">
                        {[1, 2].map((i) => <div key={i} className="card rounded-2xl h-64 shimmer" />)}
                    </div>
                ) : (
                    <div className="grid md:grid-cols-2 gap-6">
                        {contests.map((c) => (
                            <Link key={c.id} to={`/cuoc-thi/${c.id}`} className="card card-hover overflow-hidden block group fade-up" data-testid={`contest-card-${c.id}`}>
                                <div className="relative h-44 overflow-hidden">
                                    {c.cover_image && <img src={c.cover_image} alt={c.title} className="w-full h-full object-cover opacity-70 group-hover:opacity-90 transition" />}
                                    <div className="absolute inset-0 bg-gradient-to-t from-[var(--navy)] via-transparent to-transparent" />
                                    <div className="absolute top-3 right-3 badge badge-gold">{STATUS_LABEL[c.status]}</div>
                                </div>
                                <div className="p-6">
                                    <h3 className="font-heading text-xl font-semibold mb-3 group-hover:text-[var(--gold-deep)] transition">{c.title}</h3>
                                    <p className="text-sm text-slate-500 line-clamp-2 mb-4">{c.description}</p>
                                    <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-slate-500">
                                        <span className="flex items-center gap-1"><Clock className="w-3 h-3 text-[var(--gold-deep)]" /> {c.duration_minutes} phút</span>
                                        <span className="flex items-center gap-1"><ListChecks className="w-3 h-3 text-[var(--gold-deep)]" /> {c.num_mcq} câu trắc nghiệm</span>
                                        {c.has_essay && <span className="flex items-center gap-1"><Pencil className="w-3 h-3 text-[var(--gold-deep)]" /> 1 bài tự luận</span>}
                                        <span className="flex items-center gap-1"><Users className="w-3 h-3 text-[var(--gold-deep)]" /> {c.total_participants || 0} thí sinh</span>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </main>
    );
}
